<template>
  <div class="container overflow-hidden">
    <b-link
      class="font-weight-bold d-block text-nowrap mr-3 mb-2"
      @click="mudarComponente()"
    >
      <el-button
        id="voltar-lista-chat-fluxo"
        style="border: none; background-color: transparent;"
        type="button"
        class="is-plain"
      >
        <i class="el-icon-back" />
        Fluxos
      </el-button>
    </b-link>
    <div class="row gx-5n mt-2">
      <div class="card col-12">

        <b-tabs
          pills
          align="start"
          @input="Listavariaveis"
        >
          <b-tab
            title="Personalize"
            active
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'design')"
          >
            <b-card-text>
              <div class="personalize-layout">

                <!-- ── CARD 1: Chat ─────────────────────────────────── -->
                <div class="dk-section-card">
                  <div class="dk-section-header">
                    <div class="dk-section-header-left">
                      <feather-icon icon="MessageCircleIcon" size="18" class="dk-section-icon" />
                      <span class="dk-section-title">Chat</span>
                    </div>
                    <div class="dk-section-header-right">
                      <span class="dk-status-label">{{ chatIsActive ? 'Ativo' : 'Inativo' }}</span>
                      <b-form-checkbox
                        v-model="autoPlayer"
                        :value="1"
                        :unchecked-value="0"
                        class="custom-control-success dk-toggle"
                        name="check-button"
                        switch
                        inline
                      />
                    </div>
                  </div>
                  <div class="dk-section-body">
                    <!-- ID do Chat para embed -->
                    <div class="dk-field-group">
                      <label class="dk-label">
                        <feather-icon icon="CodeIcon" size="13" class="mr-1" />
                        Script de Embed
                        <span class="dk-hint">Cole este script no HTML do seu site</span>
                      </label>
                      <div class="dk-embed-copy">
                        <code class="dk-embed-code">&lt;script src="https://vslbooster.com/js/booster.min.js" data-booster="{{ chatId }}" async&gt;&lt;/script&gt;</code>
                        <button class="dk-embed-btn" @click="copyEmbed" title="Copiar script">
                          <feather-icon :icon="embedCopied ? 'CheckIcon' : 'CopyIcon'" size="14" />
                          {{ embedCopied ? 'Copiado!' : 'Copiar' }}
                        </button>
                      </div>
                    </div>

                    <div class="dk-field-group">
                      <label class="dk-label" for="nome-chat-fluxo">
                        <feather-icon icon="TagIcon" size="13" class="mr-1" />
                        Nome do Chat
                      </label>
                      <input
                        id="nome-chat-fluxo"
                        v-model="chat.name"
                        type="text"
                        class="dk-input"
                        placeholder="Ex: Chat Principal — Home"
                      >
                    </div>
                    <div class="dk-field-group">
                      <label class="dk-label" for="chamada-inicial-fluxo">
                        <feather-icon icon="MessageSquareIcon" size="13" class="mr-1" />
                        Chamada Inicial
                        <span class="dk-hint">Primeira mensagem exibida ao visitante</span>
                      </label>
                      <div id="chamada-inicial-fluxo" class="dk-tinymce-wrap">
                        <Info
                          :id="`chamada_inicial_${chat.id}`"
                          :message="chat.chamadaInicial"
                          indice="chamada_inteligente"
                          @atualizarMessage="updatedMessageInical($event)"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── CARD: Modo de Atendimento ──────────────────── -->
                <div class="dk-section-card">
                  <div class="dk-section-header">
                    <div class="dk-section-header-left">
                      <feather-icon icon="CpuIcon" size="18" class="dk-section-icon" />
                      <span class="dk-section-title">Modo de Atendimento</span>
                    </div>
                  </div>
                  <div class="dk-section-body">
                    <div class="dk-mode-toggle">
                      <button
                        type="button"
                        class="dk-mode-btn"
                        :class="{ 'dk-mode-btn--active': chatMode === 'flow' }"
                        @click="setChatMode('flow')"
                      >
                        <feather-icon icon="GitBranchIcon" size="16" />
                        <div>
                          <div class="dk-mode-btn__title">Fluxo Manual</div>
                          <div class="dk-mode-btn__sub">Perguntas e respostas pre-definidas</div>
                        </div>
                      </button>
                      <button
                        type="button"
                        class="dk-mode-btn"
                        :class="{ 'dk-mode-btn--active': chatMode === 'ai' }"
                        @click="setChatMode('ai')"
                      >
                        <feather-icon icon="ZapIcon" size="16" />
                        <div>
                          <div class="dk-mode-btn__title">Agente com IA</div>
                          <div class="dk-mode-btn__sub">Respostas automaticas com inteligencia artificial</div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- ── CARD 2: E-mail & Notificações ──────────────── -->
                <div class="dk-section-card">
                  <div class="dk-section-header">
                    <div class="dk-section-header-left">
                      <feather-icon icon="MailIcon" size="18" class="dk-section-icon" />
                      <span class="dk-section-title">E-mail &amp; Notificações</span>
                    </div>
                  </div>
                  <div class="dk-section-body">
                    <div class="dk-field-group">
                      <label class="dk-label" for="email-chat-fluxo">
                        <feather-icon icon="AtSignIcon" size="13" class="mr-1" />
                        E-mail para receber leads
                        <span class="dk-hint">Novos leads serão notificados para este endereço</span>
                      </label>
                      <input
                        id="email-chat-fluxo"
                        v-model="chat.Email"
                        type="email"
                        class="dk-input"
                        placeholder="seu@email.com.br"
                        :disabled="chat.email_condicional_status === 1 || chat.email_condicional_status === '1'"
                      >
                    </div>

                    <div id="email-condicional-email-chat-fluxo" class="dk-field-group">
                      <div class="dk-toggle-row">
                        <div class="dk-toggle-row-text">
                          <span class="dk-label mb-0">E-mail condicional</span>
                          <span class="dk-hint">Direcione notificações por condição específica</span>
                        </div>
                        <div class="dk-toggle-row-control">
                          <b-form-radio-group
                            v-model="chat.email_condicional_status"
                            :options="[{ text: 'Sim', value: 1 }, { text: 'Não', value: 0 }]"
                          />
                          <feather-icon
                            v-b-tooltip.hover.top="'Quando ativado, você pode configurar e-mails diferentes para cada condição de resposta do lead.'"
                            icon="InfoIcon"
                            size="15"
                            class="dk-info-icon"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      v-show="chat.email_condicional_status === 1 || chat.email_condicional_status === '1'"
                      class="dk-conditional-block"
                    >
                      <b-form
                        ref="formEmail"
                        :style="{height: trHeight}"
                        class="repeater-form"
                        @submit.prevent="repeateAgain"
                      >
                        <b-row
                          v-for="(item, index) in items"
                          :id="item.id"
                          :key="item.id"
                          ref="row"
                          class="dk-repeater-row align-items-end"
                        >
                          <b-col md="3">
                            <b-form-group label="Variável" label-for="cost" class="mb-1">
                              <v-select
                                v-model="item.variavel"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="label"
                                :options="variaveis"
                                placeholder="Selecione..."
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="2">
                            <b-form-group label="Condição" label-for="cost" class="mb-1">
                              <v-select
                                v-model="item.condicao"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="title"
                                :options="condicao"
                                disabled
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="2">
                            <b-form-group label="Valor" label-for="quantity" class="mb-1">
                              <v-select
                                v-model="item.valor"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="name"
                                :options="item.variavel.options"
                                placeholder="Selecione..."
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            v-if="item.valor != null && item.variavel != null && item.condicao != null"
                            md="4"
                          >
                            <b-form-group label="E-mail destino" label-for="h-email" class="mb-1">
                              <b-form-input
                                v-model="item.email"
                                type="email"
                                placeholder="destino@email.com"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col lg="1" md="2" class="mb-1">
                            <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              size="sm"
                              class="dk-remove-btn"
                              @click="removeItem(index)"
                            >
                              <feather-icon icon="Trash2Icon" size="14" />
                            </b-button>
                          </b-col>
                          <b-col cols="12">
                            <hr class="dk-divider">
                          </b-col>
                        </b-row>
                      </b-form>
                      <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        class="dk-btn-add"
                        @click="repeateAgain"
                      >
                        <feather-icon icon="PlusIcon" size="14" class="mr-50" />
                        Adicionar condição
                      </b-button>
                    </div>
                  </div>
                </div>

                <!-- ── CARD 3: Páginas & Campanhas ─────────────────── -->
                <div class="dk-section-card">
                  <div class="dk-section-header">
                    <div class="dk-section-header-left">
                      <feather-icon icon="GlobeIcon" size="18" class="dk-section-icon" />
                      <span class="dk-section-title">Páginas &amp; Campanhas</span>
                    </div>
                  </div>
                  <div class="dk-section-body">
                    <div class="dk-field-group">
                      <label class="dk-label" for="dominio-chat-fluxo">
                        <feather-icon icon="LinkIcon" size="13" class="mr-1" />
                        Domínio
                        <span v-if="getUserData.user_role !== 'admin'" class="dk-badge-readonly">Somente leitura</span>
                      </label>
                      <input
                        id="dominio-chat-fluxo"
                        v-model="getDomainChateByRole"
                        :disabled="getUserData.user_role === 'admin' ? false : true"
                        type="text"
                        class="dk-input"
                        placeholder="seusite.com.br"
                      >
                    </div>

                    <div class="dk-field-group">
                      <div class="dk-toggle-row">
                        <div class="dk-toggle-row-text">
                          <span class="dk-label mb-0">Exibir em todas as páginas</span>
                          <span class="dk-hint">Quando desativado, o chat aparece apenas na URL ou palavra-chave definida abaixo</span>
                        </div>
                        <div class="dk-toggle-row-control">
                          <b-form-radio-group
                            v-model="chat.is_trigger"
                            :options="[{ text: 'Sim', value: 0 }, { text: 'Não', value: 1 }]"
                          />
                          <feather-icon
                            v-b-tooltip.hover.top="'Caso selecionado Não, o chat aparecerá apenas na URL definida ou quando a palavra-chave for encontrada.'"
                            icon="InfoIcon"
                            size="15"
                            class="dk-info-icon"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="chat.is_trigger === '1' || chat.is_trigger === 1"
                      class="dk-field-group"
                    >
                      <label class="dk-label" for="trigger-chat-fluxo">
                        <feather-icon icon="SearchIcon" size="13" class="mr-1" />
                        URL ou palavra-chave
                        <span class="dk-hint">O chat será exibido quando esta URL ou palavra for detectada</span>
                      </label>
                      <input
                        id="trigger-chat-fluxo"
                        v-model="chat.trigger"
                        type="text"
                        class="dk-input"
                        placeholder="/minha-pagina ou #promo"
                      >
                    </div>
                  </div>
                </div>

                <!-- ── CARD 4: Design Visual ───────────────────────── -->
                <div class="dk-section-card">
                  <div class="dk-section-header">
                    <div class="dk-section-header-left">
                      <feather-icon icon="SlidersIcon" size="18" class="dk-section-icon" />
                      <span class="dk-section-title">Design Visual do Chat</span>
                    </div>
                  </div>
                  <div class="dk-section-body">
                    <div class="dk-design-grid">
                      <div class="dk-field-group">
                        <label class="dk-label" for="title-suporte-chat-fluxo">
                          <feather-icon icon="TypeIcon" size="13" class="mr-1" />
                          Título exibido no chat
                        </label>
                        <input
                          id="title-suporte-chat-fluxo"
                          v-model="design.title"
                          type="text"
                          class="dk-input"
                          placeholder="Ex: Fale conosco"
                        >
                      </div>

                      <div class="dk-design-row-2">
                        <div class="dk-field-group">
                          <label class="dk-label">
                            <feather-icon icon="LayoutIcon" size="13" class="mr-1" />
                            Posição na tela
                          </label>
                          <div class="dk-position-pills">
                            <label
                              class="dk-position-pill"
                              :class="{ active: design.side === '0' || design.side === 0 }"
                            >
                              <input
                                v-model="design.side"
                                type="radio"
                                value="0"
                                style="display:none"
                              >
                              <feather-icon icon="AlignLeftIcon" size="14" class="mr-50" />
                              Esquerda
                            </label>
                            <label
                              class="dk-position-pill"
                              :class="{ active: design.side === '1' || design.side === 1 }"
                            >
                              <input
                                v-model="design.side"
                                type="radio"
                                value="1"
                                style="display:none"
                              >
                              <feather-icon icon="AlignRightIcon" size="14" class="mr-50" />
                              Direita
                            </label>
                          </div>
                        </div>

                        <div class="dk-field-group">
                          <label class="dk-label">
                            <feather-icon icon="DropletIcon" size="13" class="mr-1" />
                            Cor principal
                          </label>
                          <div class="dk-color-picker-wrap">
                            <input
                              id="cor-suporte-chat-fluxo"
                              v-model="design.color"
                              type="color"
                              class="dk-color-input"
                            >
                            <span class="dk-color-preview-label">{{ design.color || '#000000' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="dk-field-group mt-2">
                      <label class="dk-label">
                        <feather-icon icon="UserIcon" size="13" class="mr-1" />
                        Avatar do Chat
                        <span class="dk-hint">Clique no + para enviar uma imagem ou escolha um dos modelos</span>
                      </label>

                      <!-- Abas de categoria -->
                      <div class="dk-avatar-tabs">
                        <button
                          v-for="cat in avatarCategories"
                          :key="cat.key"
                          class="dk-avatar-tab"
                          :class="{ 'dk-avatar-tab-active': avatarCategory === cat.key }"
                          @click="avatarCategory = cat.key"
                        >
                          <feather-icon :icon="cat.icon" size="13" class="mr-50" />
                          {{ cat.label }}
                        </button>
                      </div>

                      <div class="dk-avatar-grid">
                        <div class="dk-avatar-upload-slot">
                          <input
                            id="file-input"
                            type="file"
                            accept="image/*"
                            class="file-input"
                            @change="onFileChange($event)"
                          >
                          <label for="file-input" class="dk-avatar-upload-label">
                            <img
                              v-if="design.avatar"
                              :src="design.avatar"
                              class="dk-avatar-img"
                            >
                            <div v-else class="dk-avatar-placeholder">
                              <feather-icon
                                id="input-file-escolha-avatar-chat-fluxo"
                                icon="UploadCloudIcon"
                                size="22"
                              />
                              <span>Enviar foto</span>
                            </div>
                            <div class="dk-avatar-overlay">
                              <feather-icon icon="CameraIcon" size="18" />
                            </div>
                          </label>
                        </div>

                        <div
                          id="avatares-escolha-chat-fluxo"
                          class="dk-avatar-list"
                        >
                          <div
                            v-for="avatar in filteredAvatars"
                            :key="avatar.url"
                            class="dk-avatar-option"
                            :class="{ 'dk-avatar-selected': avatar.url === imagemSelecionada }"
                            @click="selecionaImagem(avatar.url)"
                          >
                            <img :src="avatar.url" class="dk-avatar-img" :alt="avatar.name">
                            <div v-if="avatar.url === imagemSelecionada" class="dk-avatar-check">
                              <feather-icon icon="CheckIcon" size="14" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ── Botão salvar ─────────────────────────────────── -->
                <div class="dk-save-bar">
                  <button
                    id="btn-salvar-chat-fluxo"
                    class="dk-btn-save"
                    @click="atualizarChat(); atualizarDesign();"
                  >
                    <feather-icon icon="SaveIcon" size="16" class="mr-75" />
                    Salvar alterações
                  </button>
                </div>

              </div>
            </b-card-text>
          </b-tab>
          <b-tab
            v-if="chatMode === 'flow'"
            id="tab-fluxo-messagem-chat-fluxo"
            title="Fluxo de Mensagem"
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'fluxo')"
          >
            <b-card-text>
              <FluxoMensagem />
            </b-card-text>
          </b-tab>
          <b-tab
            v-if="chatMode === 'ai'"
            id="tab-ia-chat"
            title="Agente IA"
          >
            <b-card-text>
              <ChatAiConfig :chat-id="chatId" />
            </b-card-text>
          </b-tab>
          <b-tab
            id="tab-integre-sistema-chat"
            title="Integre com Sistemas"
            @click="$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'integreSistema')"
          >
            <b-card-text>
              <IntegreSistema />
            </b-card-text>
          </b-tab>
        </b-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs, BTab, BFormGroup, BFormCheckboxGroup, BFormCheckbox, BFormRadioGroup, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import IntegreSistema from '@/views/App/Chat/integreSistema.vue'
import FluxoMensagem from '@/views/App/Chat/FluxoMensagem.vue'
import ChatAiConfig from '@/views/App/Chat/ChatAiConfig.vue'
import { useApiAWS, useApi } from '@/composables/useApi'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import Info from './Info.vue'

const apiAws = useApiAWS()
const apiBack = useApi()

export default {

  components: {
    IntegreSistema,
    FluxoMensagem,
    ChatAiConfig,
    BTabs,
    BTab,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormRadioGroup,
    VBTooltip,
    Info,
    vSelect,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [],
      dir: 'ltr',
      variaveis: [],
      condicao: ['é'],
      option: [],
      nextTodoId: 2,
      chamadaInicial: '',
      chatId: this.$route.query.id_chat,
      chatMode: 'flow',
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      autoPlayer: 0,
      embedCopied: false,
      imagemSelecionada: '',
      chat: [],
      design: [],
      avatarCategory: 'todos',
      avatarCategories: [
        { key: 'todos', label: 'Todos', icon: 'GridIcon' },
        { key: 'casual', label: 'Casual', icon: 'SmileIcon' },
        { key: 'executivo', label: 'Executivo', icon: 'BriefcaseIcon' },
        { key: 'moderno', label: 'Moderno', icon: 'ZapIcon' },
      ],
      avatarList: [
        // ── Casual (originais) ──
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Alberto.webp', name: 'Alberto', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ataliba.webp', name: 'Ataliba', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Braga.webp', name: 'Braga', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Bruna.webp', name: 'Bruna', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Elsa.webp', name: 'Elsa', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Franco.webp', name: 'Franco', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Fred.webp', name: 'Fred', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Harumi.webp', name: 'Harumi', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Kim.webp', name: 'Kim', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Leopoldo.webp', name: 'Leopoldo', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Patricia.webp', name: 'Patricia', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ramon.webp', name: 'Ramon', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Raquel.webp', name: 'Raquel', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Sakura.webp', name: 'Sakura', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Shin.webp', name: 'Shin', cat: 'casual' },
        { url: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Silvia.webp', name: 'Silvia', cat: 'casual' },
        // ── Executivo (fotos profissionais — randomuser.me com seeds fixas) ──
        { url: 'https://randomuser.me/api/portraits/men/32.jpg', name: 'Ricardo', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/women/44.jpg', name: 'Helena', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/men/52.jpg', name: 'Marcos', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/women/26.jpg', name: 'Carolina', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/men/46.jpg', name: 'Fernando', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/women/65.jpg', name: 'Beatriz', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/men/75.jpg', name: 'Gustavo', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/women/33.jpg', name: 'Renata', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/men/86.jpg', name: 'Roberto', cat: 'executivo' },
        { url: 'https://randomuser.me/api/portraits/women/57.jpg', name: 'Patricia', cat: 'executivo' },
        // ── Moderno (fotos jovens/modernas) ──
        { url: 'https://randomuser.me/api/portraits/women/90.jpg', name: 'Luna', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/men/11.jpg', name: 'Kai', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/women/21.jpg', name: 'Nina', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/men/18.jpg', name: 'Leo', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/women/79.jpg', name: 'Maya', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/men/22.jpg', name: 'Theo', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/women/85.jpg', name: 'Iris', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/men/29.jpg', name: 'Davi', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/women/36.jpg', name: 'Sofia', cat: 'moderno' },
        { url: 'https://randomuser.me/api/portraits/men/35.jpg', name: 'Enzo', cat: 'moderno' },
      ],
    }
  },
  computed: {
    filteredAvatars() {
      if (this.avatarCategory === 'todos') return this.avatarList
      return this.avatarList.filter(a => a.cat === this.avatarCategory)
    },
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    chatIsActive() {
      return [1, '1', true].includes(this.autoPlayer)
    },
    autoPlayerValue() {
      return this.autoPlayer ? 1 : 0
    },
    getDomainChateByRole: {
      get() {
        if (this.getUserData.user_role !== 'admin') {
          return this.getUserData.user_domain
        }
        return this.chat.domain
      },
      set(value) {
        this.chat.domain = value
      },
    },
  },
  watch: {

    getDomainChateByRole: {
      handler() {
        this.chat.domain = this.getDomainChateByRole
      },
      immediate: true,
    },
  },
  mounted() {
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', 'design')
    this.Listavariaveis()
    this.loadChatMode()
    this.buscarInfoChat().then(() => {
      this.initTrHeight()
    })
  },

  created() {
    window.addEventListener('resize', this.initTrHeight, this.Listavariaveis)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },

  methods: {
    async setChatMode(mode) {
      this.chatMode = mode
      // Salva o modo na config da IA (ai_enabled = 1 se ai, 0 se flow)
      try {
        await fetch(`${this.VUE_APP_HOST_API_BACKEND}/chat-ai/${this.chatId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ai_enabled: mode === 'ai' ? 1 : 0 }),
        })
      } catch (e) { /* silencioso */ }
    },
    async loadChatMode() {
      if (!this.chatId) return
      try {
        const resp = await fetch(`${this.VUE_APP_HOST_API_BACKEND}/chat-ai/${this.chatId}`)
        const data = await resp.json()
        this.chatMode = data.ai_enabled ? 'ai' : 'flow'
      } catch (e) { /* fallback flow */ }
    },
    Listavariaveis() {
      apiBack.get(`/getFluxoEXTByIdFluxoAndOptions/${this.chatId}`)
        .then(response => {
          const resposta = JSON.parse(JSON.stringify(response.data))
          this.variaveis = resposta
            .filter(valor => valor.type === 2)
            .map(valor => ({
              id: valor.id,
              label: valor.label,
              options: JSON.parse(valor.options),
            }))
        })
        .catch(error => {
          console.error(error)
        })
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
        variavel: {},
        condicao: 'é',
        valor: null,
        email: '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.formEmail.scrollHeight)
      })
    },
    mudarComponente() {
      this.$store.commit('AppChatbooster/SET_CURRENT_TAB', {
        title: 'Gerenciar Fluxos',
        component: 'chat',
      })
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ params: {}, query: {} })
      }
    },
    buscarInfoChat() {
      return apiBack.get(`/chatInner/${this.chatId}`)
        .then(response => {
          const data = response.data.json ? response.data : { json: response.data }
          if (!data.json || !data.json[0]) return
          this.autoPlayer = ['true', true, 1, '1'].includes(data.json[0].status) ? 1 : 0
          if (JSON.parse(data.json[0].email_condicional) === null) {
            this.items = []
          } else {
            this.items = JSON.parse(data.json[0].email_condicional)
          }

          this.chat = data.json[0]
          this.design = data.json[0].design
        })
        .catch(err => console.error(err))
    },
    async updatedAvatarChat(url) {
      this.design.avatar = url
      await apiBack.put(`/chatd/${this.chatId}`, {
        avatar: url,
        color: this.design.color,
        side: this.design.side,
        subTitle: 'Online Agora',
        title: this.design.title,
      })
    },
    async uploadAvatarChat(file) {
      const formData = new FormData()
      formData.append('video', file)
      formData.append('caminho', `${this.getUserData.user_file_key}UploadImageChat/`)
      await apiAws.post('/thumb', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async response => {
        this.design.avatar = response.data.data.fileUrl
        await this.updatedAvatarChat(response.data.data.fileUrl)
      }).catch(err => {
        console.log(err)
      })
    },
    async onFileChange(event) {
      const file = event.target.files[0]
      await this.uploadAvatarChat(file)
      const reader = new FileReader()
      reader.onload = () => {
        // Atualiza o preview do avatar com o arquivo selecionado
        this.design.avatar = reader.result
      }
      reader.readAsDataURL(file)
    },
    fluxo() {
      this.$router.push({ name: 'fluxoMensagem' })
    },
    updatedMessageInical(event) {
      this.chamadaInicial = JSON.parse(JSON.stringify(event))
    },
    async atualizarChat() {
      const urlSemProtocolo = this.chat.domain.replace(/^https?:\/\//, '')
      const posicaoBarra = urlSemProtocolo.indexOf('/')
      this.chat.domain = `${posicaoBarra === -1 ? urlSemProtocolo : urlSemProtocolo.slice(0, posicaoBarra)}`
      if (this.chat.is_trigger === 0) {
        this.chat.trigger = ''
      }
      await apiBack.put(`/chat/${this.chatId}`, {
        name: this.chat.name,
        chamadaInicial: this.chamadaInicial === '' ? this.chat.chamadaInicial : this.chamadaInicial,
        email_chat: this.chat.Email,
        triggerc: this.chat.trigger,
        is_trigger: this.chat.is_trigger,
        email_condicional: JSON.stringify(this.items),
        email_condicional_status: this.chat.email_condicional_status,
        status: this.autoPlayerValue,
        domain: this.chat.domain,
      })
    },
    async atualizarDesign() {
      await apiBack.put(`/chatd/${this.chatId}`, {
        avatar: this.design.avatar,
        color: this.design.color,
        side: this.design.side,
        subTitle: 'Online Agora',
        title: this.design.title,
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Salvo com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    copyEmbed() {
      const script = `<script src="https://vslbooster.com/js/booster.min.js" data-booster="${this.chatId}" async><\/script>`
      navigator.clipboard.writeText(script).then(() => {
        this.embedCopied = true
        setTimeout(() => { this.embedCopied = false }, 2000)
        this.$message({ type: 'success', message: 'Script copiado!' })
      })
    },
    selecionaImagem(avatar) {
      this.design.avatar = avatar
    },
    getValueBoolean(value) {
      return ['true', true, 1, '1'].indexOf(value) !== -1 ? 1 : 0
    },
    async changeStatus(chat) {
      chat.status = !this.getValueBoolean(chat.status)
      await apiBack.put(`/chat/${chat.id}`, { ...chat, status: this.getValueBoolean(chat.status) })
        .then(() => {
          this.listaChat()
        })
        .catch(err => console.error(err))
    },

  },

}
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';

/* ─── Variáveis DK ───────────────────────────── */
$navy:  #0D3349;
$orange:#E86A10;
$gold:  #F5B935;
$cream: #EDE8C4;
$border:#DDE3EA;
$bg:    #F4F6F9;

/* ─── Layout geral ───────────────────────────── */
.personalize-layout {
  padding: 24px 0 100px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ─── Cards de seção ─────────────────────────── */
.dk-section-card {
  background: var(--dk-bg-card, #fff);
  border-radius: 12px;
  border: 1px solid $border;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(13, 51, 73, 0.06);
}

/* Mode toggle */
.dk-mode-toggle { display: flex; gap: 10px; }
.dk-mode-btn {
  flex: 1; display: flex; align-items: flex-start; gap: 12px;
  padding: 16px; border-radius: 10px; cursor: pointer;
  background: rgba(255,255,255,0.03); border: 2px solid rgba(255,255,255,0.08);
  color: var(--dk-text-muted, #8a94a6); transition: all 0.2s;
  text-align: left; font-family: inherit;
}
.dk-mode-btn:hover { border-color: rgba(255,255,255,0.15); color: var(--dk-text-primary, #e2e8f0); }
.dk-mode-btn--active {
  background: rgba(232,106,16,0.08); border-color: $orange; color: $orange;
}
.dk-mode-btn--active .dk-mode-btn__title { color: $orange; }
.dk-mode-btn__title { font-size: 13px; font-weight: 700; margin-bottom: 2px; }
.dk-mode-btn__sub { font-size: 11px; opacity: 0.7; line-height: 1.4; }

.dk-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 22px;
  background: $navy;
  gap: 10px;
}

.dk-section-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dk-section-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dk-section-icon {
  color: $gold;
  flex-shrink: 0;
}

.dk-section-title {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.01em;
}

.dk-status-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255,255,255,0.75);
}

.dk-toggle {
  margin: 0 !important;
}

.dk-section-body {
  padding: 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ─── Campos ─────────────────────────────────── */
.dk-field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dk-label {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: $navy;
  margin-bottom: 0;
  gap: 4px;
  flex-wrap: wrap;
}

.dk-hint {
  font-size: 11px;
  font-weight: 400;
  color: #5f6b7a !important;
  display: block;
  width: 100%;
  margin-top: 1px;
}

.dark-layout .dk-hint {
  color: #c7d0db !important;
}

.dk-input {
  width: 100%;
  height: 42px;
  padding: 0 14px;
  border: 1.5px solid $border;
  border-radius: 8px;
  font-size: 14px;
  color: var(--dk-text-primary, #2d3748);
  background: var(--dk-bg-card-hover, #fafbfc);
  transition: border-color .18s, box-shadow .18s;
  outline: none;

  &:focus {
    border-color: $navy;
    box-shadow: 0 0 0 3px rgba(13, 51, 73, 0.08);
    background: var(--dk-bg-card, #fff);
  }

  &:disabled {
    background: var(--dk-bg-inset, #f0f2f5);
    color: var(--dk-text-faint, #aab0b9);
    cursor: not-allowed;
  }
}

.dk-tinymce-wrap {
  border: 1.5px solid $border;
  border-radius: 8px;
  overflow: hidden;
  min-height: 60px;
}

/* ─── Toggle row (sim/não + info) ────────────── */
.dk-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
  background: $bg;
  border-radius: 9px;
  border: 1px solid $border;
  flex-wrap: wrap;
}

.dk-toggle-row-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 200px;
}

.dk-toggle-row-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dk-info-icon {
  color: var(--dk-text-muted, #8a98a8);
  cursor: help;
  flex-shrink: 0;
}

/* ─── Badge somente leitura ──────────────────── */
.dk-badge-readonly {
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background: #aab0b9;
  padding: 1px 7px;
  border-radius: 20px;
  margin-left: 6px;
  vertical-align: middle;
}

/* ─── Bloco condicional de e-mails ───────────── */
.dk-conditional-block {
  border: 1px dashed $border;
  border-radius: 10px;
  padding: 16px;
  background: var(--dk-bg-card-hover, #fafbfc);
}

.dk-repeater-row {
  margin-bottom: 4px;
}

.dk-divider {
  border-color: $border;
  margin: 8px 0 12px;
}

.dk-remove-btn {
  padding: 6px 10px !important;
  background-image: none !important;
}

.dk-btn-add {
  display: inline-flex;
  align-items: center;
  background: $navy !important;
  background-image: none !important;
  color: #fff !important;
  border: none !important;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background .18s;

  &:hover {
    background: darken($navy, 6%) !important;
  }
}

/* ─── Design: posição pills ──────────────────── */
.dk-design-grid {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.dk-design-row-2 {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
}

.dk-position-pills {
  display: flex;
  gap: 8px;
}

.dk-position-pill {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  border-radius: 8px;
  border: 1.5px solid $border;
  font-size: 13px;
  font-weight: 600;
  color: var(--dk-text-secondary, #6b7a8d);
  cursor: pointer;
  background: var(--dk-bg-card-hover, #fafbfc);
  transition: all .18s;
  user-select: none;
  margin: 0;

  &.active {
    border-color: $navy;
    background: $navy;
    color: #fff;
  }

  &:hover:not(.active) {
    border-color: $navy;
    color: $navy;
  }
}

/* ─── Color picker ───────────────────────────── */
.dk-color-picker-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dk-color-input {
  width: 48px;
  height: 42px;
  padding: 2px;
  border: 1.5px solid $border;
  border-radius: 8px;
  cursor: pointer;
  background: none;
}

.dk-color-preview-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--dk-text-secondary, #6b7a8d);
  font-family: monospace;
}

/* ─── Embed Copy ─────────────────────────────── */
.dk-embed-copy {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--dk-bg-card, #f8fafc);
  border: 1.5px solid $border;
  border-radius: 10px;
  padding: 10px 12px;
}
.dk-embed-code {
  flex: 1;
  font-size: 11.5px;
  color: var(--dk-text-secondary, #475569);
  background: none;
  word-break: break-all;
  line-height: 1.5;
  white-space: normal;
}
.dk-embed-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1.5px solid $orange;
  background: $orange;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all .18s;
  flex-shrink: 0;

  &:hover { opacity: 0.9; }
}

/* ─── Avatar Tabs ────────────────────────────── */
.dk-avatar-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}
.dk-avatar-tab {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1.5px solid $border;
  background: $bg;
  color: var(--dk-text-secondary, #64748b);
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all .18s;

  &:hover {
    border-color: $orange;
    color: $orange;
  }
  &.dk-avatar-tab-active {
    background: $orange;
    border-color: $orange;
    color: #fff;
  }
}

/* ─── Avatar ─────────────────────────────────── */
.dk-avatar-grid {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.dk-avatar-upload-slot {
  position: relative;
  flex-shrink: 0;
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 2;
  cursor: pointer;
}

.dk-avatar-upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border: 2px dashed $border;
  background: $bg;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: border-color .18s;

  &:hover {
    border-color: $orange;
    .dk-avatar-overlay { opacity: 1; }
  }
}

.dk-avatar-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: var(--dk-text-muted, #8a98a8);
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}

.dk-avatar-overlay {
  position: absolute;
  inset: 0;
  background: rgba(13, 51, 73, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity .18s;
  border-radius: 50%;
}

.dk-avatar-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex: 1;
}

.dk-avatar-option {
  position: relative;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  cursor: pointer;
  border: 2.5px solid transparent;
  transition: border-color .18s, transform .15s;
  flex-shrink: 0;

  &:hover {
    border-color: $orange;
    transform: scale(1.06);
  }

  &.dk-avatar-selected {
    border-color: $orange;
  }
}

.dk-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.dk-avatar-check {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: $orange;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.25);
}

/* ─── Barra de salvar ────────────────────────── */
.dk-save-bar {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 14px 32px;
  background: rgba(255,255,255,0.96);
  backdrop-filter: blur(8px);
  border-top: 1px solid $border;
  display: flex;
  justify-content: flex-end;
  z-index: 999;
  box-shadow: 0 -2px 16px rgba(13, 51, 73, 0.08);
}

.dk-btn-save {
  display: inline-flex;
  align-items: center;
  background: $orange !important;
  background-image: none !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  padding: 11px 28px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.01em;
  transition: background .18s, transform .12s;
  box-shadow: 0 4px 14px rgba(232, 106, 16, 0.35);

  &:hover {
    background: darken($orange, 8%) !important;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

/* ─── Legados (não remover — usados em abas filhas) */
.el-icon-document-copy {
  padding: 1px;
  font-size: 25px;
  color: var(--dk-text-primary, #2e2e2f);
  transition: color .15s linear;
}

/* Tornar opções dos radios não-brancas para melhor contraste */
::v-deep .dk-toggle-row-control .custom-control-label,
::v-deep .dk-toggle-row-control .form-check-label,
::v-deep .dk-toggle-row-control label {
  color: $navy !important;
  background: rgba(255,255,255,0.92) !important;
  padding: 6px 10px !important;
  border-radius: 8px !important;
  font-weight: 700 !important;
  border: 1px solid rgba(13,51,73,0.06) !important;
}

/* Estado selecionado continua destacado em laranja */
::v-deep .dk-toggle-row-control .custom-control-input:checked ~ .custom-control-label,
::v-deep .dk-toggle-row-control .custom-control-input:checked ~ .form-check-label {
  background: $orange !important;
  color: #fff !important;
  border-color: $orange !important;
}

/* Em layout escuro, usar texto claro sobre fundo escuro sem ser branco puro */
.dark-layout ::v-deep .dk-toggle-row-control .custom-control-label,
.dark-layout ::v-deep .dk-toggle-row-control .form-check-label {
  color: #E6EEF6 !important;
  background: rgba(13,20,30,0.28) !important;
}
</style>
